import HttpClient from "../../utils/http";
import { downloadExcel, downloadExcelForSmsWhstapp, getExcelUploadedList, uploadexcelFileEndPoint, uploadexcelFileNotificationEndPoint, whatsappSmsnotificationList } from "../constants/api_endpoints";

export function getExcelUploadData({
    page,
    size,
    type,
    startDate,
    endDate,
    status
  }: {
    page: number | null;
    size: number | null;
    type: string | null;
    startDate: string;
    endDate: string;
    status: number | null;
  }) {
     
    let url = `${getExcelUploadedList}/?type=${type}&page=${page}&size=${size}`;
    if(startDate!=="" && endDate!==""){
        url +=`&fromDate=${startDate}&toDate=${endDate}`
    }
    if(status){
      url+=`&status=${status}`
    }
    return HttpClient.get(url);
  }

  export function getNotificationBulkUploadData({
    page,
    size,
    startDate,
    endDate,
    status
  }: {
    page: number | null;
    size: number | null;
    startDate: string;
    endDate: string;
    status: number | null;
  }) {
     
    let url = `${whatsappSmsnotificationList}?page=${page}&size=${size}`;
    if(startDate!=="" && endDate!==""){
        url +=`&fromDate=${startDate}&toDate=${endDate}`
    }
    if(status){
      url+=`&status=${status}`
    }
    return HttpClient.get(url);
  }

  export function UploadExcelFile({
    file,
    type,
  }: {
    file: File;
    type: string | null;
  }) {
    var formData = new FormData();
    formData.append('type', type!);
    formData.append('files', file);
  
  
    let url = `${uploadexcelFileEndPoint}`;
    return HttpClient.post(url, formData,
      {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  

  export function UploadExcelFileForNotification({
    file,
    type,
  }: {
    file: File;
    type: string | null;
  }) {
    var formData = new FormData();
    formData.append('type', type!);
    formData.append('files', file);
  
  
    let url = `${uploadexcelFileNotificationEndPoint}`;
    return HttpClient.post(url, formData,
      {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  export function downloadExcelApiCall({taskId}:{taskId:number}){
      let url=`${downloadExcel}/?taskId=${taskId}`
      return HttpClient.get(url, {
        responseType: "blob",
      });
  }

  export function downloadExcelSmsWhstapp({taskId, typeOfNotification}:{taskId:number, typeOfNotification:string}){
    let url=`${downloadExcelForSmsWhstapp}/?taskId=${taskId}&typeOfNotification=${typeOfNotification}`
    return HttpClient.get(url, {
      responseType: "blob",
    });
}